import { type V3ApiFailedResponse } from 'javascripts/services/v3ApiClient';
import toast from 'helpers/toast';

type HandleMaxCharErrorParams = {
  errors: V3ApiFailedResponse['errors'];
  defaultErrorMsg: string;
  on422Response?: () => void;
};

export const handleMaxCharError = ({
  errors,
  defaultErrorMsg,
  on422Response,
}: HandleMaxCharErrorParams) => {
  if (!errors.length) {
    toast.error(defaultErrorMsg);
    return;
  }

  const error = errors[0];

  if (error?.status !== '422') {
    toast.error(defaultErrorMsg);
    return;
  }

  // Show message for invalid content (usually over max char limit)
  toast.error(error.detail);

  if (on422Response) {
    on422Response();
  }
};
